/**
 * Random Alias Generator for Superhero Names
 * Combines creative adjectives with powerful nouns to create unique aliases
 */

const ADJECTIVES = [
  'Mysterious',
  'Mighty',
  'Brilliant',
  'Fearless',
  'Cosmic',
  'Radiant',
  'Shadow',
  'Quantum',
  'Eternal',
  'Blazing',
  'Thunder',
  'Crystal',
  'Phantom',
  'Stellar',
  'Arcane',
  'Valiant',
  'Crimson',
  'Azure',
  'Golden',
  'Silver',
  'Obsidian',
  'Emerald',
  'Spectral',
  'Infinite',
  'Legendary',
  'Epic',
  'Supreme',
  'Ultimate',
  'Invincible',
  'Unstoppable',
  'Enigmatic',
  'Celestial',
  'Temporal',
  'Dimensional',
  'Elemental',
  'Primal',
  'Ancient',
  'Mystic',
  'Astral',
  'Nebula',
  'Galactic',
  'Void',
  'Plasma',
  'Kinetic',
  'Psychic',
  'Cyber',
  'Neon',
  'Titanium',
  'Omega',
  'Alpha',
];

const NOUNS = [
  'Scholar',
  'Guardian',
  'Sentinel',
  'Champion',
  'Warrior',
  'Sage',
  'Knight',
  'Paladin',
  'Protector',
  'Defender',
  'Avenger',
  'Crusader',
  'Ranger',
  'Warden',
  'Keeper',
  'Seeker',
  'Hunter',
  'Striker',
  'Phantom',
  'Specter',
  'Wraith',
  'Spirit',
  'Phoenix',
  'Dragon',
  'Eagle',
  'Falcon',
  'Hawk',
  'Wolf',
  'Lion',
  'Tiger',
  'Panther',
  'Viper',
  'Cobra',
  'Raven',
  'Storm',
  'Tempest',
  'Blaze',
  'Inferno',
  'Frost',
  'Glacier',
  'Thunder',
  'Lightning',
  'Bolt',
  'Flash',
  'Pulse',
  'Wave',
  'Tide',
  'Quake',
  'Nova',
  'Star',
];

/**
 * Generates a random superhero alias by combining an adjective and a noun
 * @returns A randomly generated superhero alias (e.g., "Mysterious Scholar")
 */
export function generateRandomAlias(): string {
  const randomAdjective =
    ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const randomNoun = NOUNS[Math.floor(Math.random() * NOUNS.length)];

  return `${randomAdjective} ${randomNoun}`;
}

/**
 * Generates multiple unique random aliases
 * @param count Number of aliases to generate
 * @returns Array of unique random aliases
 */
export function generateMultipleAliases(count: number): string[] {
  const aliases = new Set<string>();

  while (aliases.size < count && aliases.size < ADJECTIVES.length * NOUNS.length) {
    aliases.add(generateRandomAlias());
  }

  return Array.from(aliases);
}

/**
 * Gets a random alias with a prefix (e.g., "The Mysterious Scholar")
 * @param includeThe Whether to include "The" prefix
 * @returns A random alias with optional "The" prefix
 */
export function generateRandomAliasWithPrefix(includeThe = true): string {
  const alias = generateRandomAlias();
  return includeThe ? `The ${alias}` : alias;
}
